<form [formGroup]="form">
  <div class="crud-item-section">
    <span>
      <mat-form-field matTooltip="Created By">
        <mat-label i18n="@@type.Asset.createdBy">Created By</mat-label>
        <input matInput formControlName="createdBy" id="createdBy" [ngModel]="item?.createdBy" #createdBy maxlength="255"
          placeholder="Created By" disabled>
      </mat-form-field>
    </span>

    <span>
      <mat-form-field matTooltip="Created Date">
        <mat-label i18n="@@type.Asset.createdDate">Created Date</mat-label>
        <input matInput formControlName="createdDate" id="createdDate" [ngModel]="item?.createdDate" #createdDate
          [matDatepicker]="createdDateDatePicker" placeholder="Created Date" disabled>
        <mat-datepicker-toggle matSuffix [for]="createdDateDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #createdDateDatePicker color="primary"></mat-datepicker>
      </mat-form-field>
    </span>

    <span>
      <mat-form-field matTooltip="Updated By">
        <mat-label i18n="@@type.Asset.updatedBy">Updated By</mat-label>
        <input matInput formControlName="updatedBy" id="updatedBy" [ngModel]="item?.updatedBy" #updatedBy maxlength="255"
          placeholder="Updated By" disabled>
      </mat-form-field>
    </span>

    <span>
      <mat-form-field matTooltip="Updated Date">
        <mat-label i18n="@@type.Asset.updatedDate">Updated Date</mat-label>
        <input matInput formControlName="updatedDate" id="updatedDate" [ngModel]="item?.updatedDate" #updatedDate
          [matDatepicker]="updatedDateDatePicker" placeholder="Updated Date" disabled>
        <mat-datepicker-toggle matSuffix [for]="updatedDateDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #updatedDateDatePicker color="primary"></mat-datepicker>
      </mat-form-field>
    </span>
  </div>

  <div class="crud-item-section" *ngIf="item?.assetType != null">
    <h2>Asset Type Guidance Text</h2>
  </div>

  <div class="crud-item-section" *ngIf="item?.assetType != null">
    <span class="guidance-text-span">
      <app-rich-text-section #guidanceTextEditor [text]="item?.assetType?.guidanceText" [readOnly]="true" [editAvailable]="false" [editToggleAvailable]="false">
      </app-rich-text-section>
    </span>
  </div>
</form>